import { object, string } from 'yup'
import { i18nErrorCodes } from '../form-utils'

const { required } = i18nErrorCodes

export default object().shape({
  bossName:     string().required(required),
  bossPosition: string().required(required),
})

export const emptyBoss = {
  bossName:     '',
  bossPosition: '',
}

export const convertBoss = ({
  bossName,
  bossPosition,
}) => ({
  boss: {
    name:     bossName,
    position: bossPosition,
  }
})



// WEBPACK FOOTER //
// ./src/components/forms/schemas/boss.schema.ts